<div class="add-model-menu">
  <button class="add-model-menu__item" (click)="onIfcSelected()" type="button">
    <ocp-themed-icon class="add-model-menu__item-icon" name="ifc-criteria-group.svg" [size]="16" />
    <div class="add-model-menu__item-content">
      <div class="add-model-menu__item-title">
        {{ 'models.add-model-options.ifc' | translate }}
      </div>
      <div class="add-model-menu__item-description">
        {{ 'models.add-model-options.ifc-description' | translate }}
      </div>
    </div>
  </button>

  <button class="add-model-menu__item" (click)="onModelSelected()" type="button">
    <ocp-themed-icon class="add-model-menu__item-icon" name="archicad.svg" [size]="16" />
    <div class="add-model-menu__item-content">
      <div class="add-model-menu__item-title">
        {{ 'models.add-model-options.model' | translate }}
      </div>
      <div class="add-model-menu__item-description">
        {{ 'models.add-model-options.model-description' | translate }}
      </div>
    </div>
  </button>
</div>
